import { useEffect, useState } from 'react';

// ✅ Importando imagens diretamente da pasta /assets/
import humanizado from '../../../assets/humanizado.png';
import pontualidade from '../../../assets/pontualidade.png';
import resultados from '../../../assets/resultados.png';
import digital from '../../../assets/digital.png';
import imposto from '../../../assets/imposto.png';
import tradicao from '../../../assets/tradicao.png';

export default function HighlightsSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('destaques');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const highlights = [
    {
      icon: 'ri-heart-line',
      title: 'Atendimento Humanizado',
      description:
        'Priorizamos o relacionamento próximo e personalizado com cada cliente, oferecendo suporte dedicado.',
      image: humanizado,
    },
    {
      icon: 'ri-time-line',
      title: 'Pontualidade Garantida',
      description:
        'Cumprimos rigorosamente todos os prazos fiscais e entregamos relatórios sempre no prazo acordado.',
      image: pontualidade,
    },
    {
      icon: 'ri-trophy-line',
      title: 'Foco em Resultados',
      description:
        'Nosso objetivo é o crescimento sustentável do seu negócio através de soluções eficientes e estratégicas.',
      image: resultados,
    },
    {
      icon: 'ri-computer-line',
      title: 'Contabilidade 100% Digital',
      description:
        'Utilizamos as mais modernas tecnologias para oferecer processos ágeis, seguros e totalmente digitalizados.',
      image: digital,
    },
    {
      icon: 'ri-file-text-line',
      title: 'Especialistas em Imposto de Renda',
      description:
        'Cuidamos do seu Imposto de Renda Pessoa Física e Jurídica com máxima precisão e economia fiscal.',
      image: imposto,
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Tradição e Confiança',
      description:
        'Mais de 60 anos de experiência em terceira geração, combinando tradição familiar com inovação.',
      image: tradicao,
    },
  ];

  return (
<section id="destaques" className="mb-0 md:mb-6 py-10 bg-gray-50">
  <div className="container mx-auto px-4 text-justify">
    <div
      className={`text-center mb-12 transform transition-all duration-1000 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
      }`}
    >
      <h2
        className="text-4xl md:text-5xl font-bold text-gray-800 mb-6"
        style={{ fontFamily: 'DM Sans, sans-serif' }}
      >
        Por que Escolher a Renzi Rossi?
      </h2>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
        Combinamos décadas de experiência com tecnologia de ponta para oferecer 
        o melhor em serviços contábeis e fiscais.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {highlights.map((highlight, index) => (
        <div
          key={index}
          className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
          style={{ transitionDelay: `${index * 100}ms` }}
        >
          <div className="relative h-48 overflow-hidden">
            <img
              src={highlight.image}
              alt={highlight.title}
              className="w-full h-full object-cover object-center transition-transform duration-300 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
          </div>

          <div className="p-6">
            <div className="flex items-center mb-4">
              {/* Ícone escondido em celular */}
              <div className="hidden md:flex w-12 h-12 bg-blue-100 rounded-lg items-center justify-center mr-4">
                <i className={`${highlight.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3
                className="text-xl font-bold text-gray-800"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {highlight.title}
              </h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              {highlight.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

  );
}
